import React, { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { observer } from 'mobx-react-lite';
import Model from '../../../model';
import { useLocation } from 'react-router';
import { useMobile } from 'utils/media';
import Icon from 'components/Icon';

import './index.sass';

const OtvetToaster = () => {
    const { isMobile } = useMobile();
    const { pathname} = useLocation();
    const isFront = pathname === '/';

    const [ top, setTop ] = useState(0);

    const { isHeaderSticky } = Model.view;
    const getTop = () => {
        if (isMobile) {
            return 0;
        }
        if (isFront && isHeaderSticky ) {
            return 72;
        }
        if (isFront && !isHeaderSticky) {
            return 106;
        }
        if (!isFront && isHeaderSticky ) {
            return 72;
        }
        if (!isFront && !isHeaderSticky) {
            return 112;
        }
    }

    useEffect(() => {
        setTop(getTop() + 16 );
    }, [isHeaderSticky])

    return <Toaster
        position={'top-right'}
        gutter={16}
        containerStyle={{
            top: `${top}px`,
            transition: 'top .2s'
        }}
        toastOptions={ {
            className: 'toast',
            style: {
                minWidth: isMobile ? '100%' : '250px',
                borderRadius: '12px',
                fontSize: '12px',
                textAlign: 'left',
                gap: '12px'
            },
            success: {
                icon: <Icon style={{color: '#37745B'}} name={'check-circle-transparent'}/>,
                style: {
                    background: 'linear-gradient(0deg, rgba(55, 116, 91, 0.10) 0%, rgba(55, 116, 91, 0.10) 100%), #FFF',
                    border: '1px solid rgba(55, 116, 91, 0.30)'
                }
            },
            loading: {
                icon: <Icon style={{color: '#D5961B'}} name={'warning-circle'}/>,
                style: {
                    background: 'linear-gradient(0deg, rgba(230, 150, 27, 0.10) 0%, rgba(230, 150, 27, 0.10) 100%), #FFF',
                    border: '1px solid rgba(230, 150, 27, 0.30)'
                }
            },
            error: {
                icon: <Icon style={{color: '#BC3B1F'}} name={'warning'}/>,
                style: {
                    background: 'linear-gradient(0deg, rgba(188, 59, 31, 0.10) 0%, rgba(188, 59, 31, 0.10) 100%), #FFF',
                    border: '1px solid rgba(188, 59, 31, 0.30)'
                }
            }
        }}
    />
}

export default observer(OtvetToaster);
